// src/pages/styles/BuyStall.styles.ts (Updated)

import styled, {css } from 'styled-components';
import {Link } from 'react-router-dom'; // Assuming you have this for StyledLink

export const BuyStallPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f8f8f8;
  min-height: 100vh;
  font-family: Arial, sans-serif;
`;

export const BuyStallForm = styled.form`
  background: #ffffff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 700px;
  margin: 30px auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 25px;
    margin: 15px auto;
  }

  @media (max-width: 480px) {
    padding: 15px;
    margin: 10px auto;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  }
`;

export const Title = styled.h2`
  color: #333;
  text-align: center;
  margin-bottom: 10px;
  font-size: 2.2em;

  @media (max-width: 480px) {
    font-size: 1.8em;
  }
`;

export const Subtitle = styled.p`
  color: #666;
  text-align: center;
  margin-bottom: 30px;
  font-size: 1.1em;

  @media (max-width: 480px) {
    font-size: 0.95em;
  }
`;
export interface MessageContainerProps {
  type: 'success' | 'error' | 'warning' | 'info'; // Include all needed types
}

export const MessageContainer = styled.div<MessageContainerProps>`
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 4px;
  color: white;
  background-color: ${({theme, type }) => 
    type === 'error' ? theme.colors.error :
    type === 'success' ? theme.colors.success :
    type === 'warning' ? '#ff9800' : // Orange for warnings
    '#2196F3' // Blue for info
  };
`;

export const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 600;
  transition: background-color 0.3s ease, transform 0.2s ease;
  min-width: 120px;
  flex: 1;
  margin: 0 5px;

  &:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
  }

  &:active {
    background-color: #004085;
    transform: translateY(0);
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

  &.previous-button {
    background-color: #6c757d;
    &:hover {
      background-color: #5a6268;
    }
  }

  @media (max-width: 500px) {
    margin: 0;
    width: 100%;
    padding: 10px;
  }
`;

export const StyledLink = styled(Link)`
  display: block;
  text-align: center;
  margin-top: 15px;
  color: #007bff;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const StepperContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin-bottom: 40px;
  width: 100%;
  max-width: 700px;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Step = styled.div<{active: boolean; completed: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;

  @media (max-width: 600px) {
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 20px;
  }

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 15px;
    left: calc(50% + 25px); /* Position after the circle */
    width: calc(100% - 50px); /* Adjust width */
    height: 2px;
    background-color: ${props => props.completed ? '#007bff' : '#ddd'};
    z-index: 0;
    transition: background-color 0.3s ease;

    @media (max-width: 600px) {
      display: none; /* Hide line in column layout */
    }
  }
`;

export const StepNumber = styled.div<{active: boolean; completed: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props => props.completed ? '#007bff' : (props.active ? '#007bff' : '#ddd')};
  color: ${props => props.completed || props.active ? 'white' : '#666'};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  margin-bottom: 10px;
  z-index: 1; /* Ensure number is above line */
  transition: background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 600px) {
    margin-right: 15px;
    margin-bottom: 0;
  }
`;

export const StepTitle = styled.div<{active: boolean; completed: boolean }>`
  color: ${props => props.active || props.completed ? '#333' : '#666'};
  font-weight: ${props => props.active ? '700' : 'normal'};
  text-align: center;
  font-size: 0.95em;

  @media (max-width: 600px) {
    text-align: left;
    font-size: 1em;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 25px;
  justify-content: flex-end; /* Align buttons to the right */

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 15px;
    align-items: stretch; /* Stretch buttons to full width */
    margin-top: 20px;
  }
`;

export const RequiredIndicator = styled.span`
  color: red;
  margin-left: 4px;
  font-size: 0.9em;
`;


// --- Styled Components specific to StallPaymentReview (Moved from StallPaymentReview.styles.ts) ---

export const PaymentReviewContainer = styled.div`
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  box-sizing: border-box;
`;

export const SectionTitle = styled.h3`
  color: #007bff;
  margin-bottom: 25px;
  font-size: 1.5em;
  text-align: center;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #007bff;
    border-radius: 5px;
  }
`;

export const DetailGroup = styled.div`
  margin-bottom: 15px;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
  display: flex;
  align-items: center;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  font-weight: 600;
  color: #555;
  width: 180px;
  flex-shrink: 0;
  margin-right: 15px;
`;

export const DetailValue = styled.span`
  color: #333;
  word-break: break-word;
  flex-grow: 1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
`;

// Note: The `Button` style is already defined above,
// so if you want a specific style for buttons in the review section,
// you might need to create a new styled component or use props on the existing Button.

export const SummarySection = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  background-color: #fcfcfc;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
`;

export const PriceHighlight = styled.div`
  font-size: 2.2em;
  font-weight: 700;
  color: #28a745;
  text-align: center;
  margin-bottom: 15px;
  letter-spacing: -0.5px;
`;

export const DurationText = styled.p`
  text-align: center;
  font-size: 1.1em;
  color: #666;
  margin-bottom: 25px;
`;

export const PaymentMethodSelection = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 25px;
  margin-bottom: 25px;

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const PaymentButton = styled.button<{selected: boolean }>`
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
  border: 2px solid ${props => props.selected ? '#007bff' : '#ddd'};
  background-color: ${props => props.selected ? '#e0f0ff' : '#f8f8f8'};
  color: ${props => props.selected ? '#007bff' : '#555'};
  transition: all 0.3s ease;
  flex: 1;

  &:hover {
    border-color: #007bff;
    background-color: #e0f0ff;
    color: #007bff;
  }

  &:disabled {
    background-color: #eee;
    color: #aaa;
    border-color: #ddd;
    cursor: not-allowed;
  }

  @media (max-width: 500px) {
    width: 100%;
    margin: 0;
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  color: white;
  font-size: 1.5em;
  flex-direction: column;
  gap: 20px;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {transform: rotate(0deg); }
    100% {transform: rotate(360deg); }
  }
`;

// New styled components for payment options in StallPaymentReview.tsx
// If you want these to be shared, keep them here. If not, define them directly in StallPaymentReview.tsx
export const PaymentOptions = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  justify-content: center;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PaymentOption = styled.div<{active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border: 2px solid ${props => props.active ? '#007bff' : '#eee'};
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props => props.active ? '#eaf6ff' : '#fcfcfc'};
  box-shadow: ${props => props.active ? '0 0 10px rgba(0, 123, 255, 0.2)' : 'none'};

  &:hover {
    border-color: #007bff;
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.1);
  }

  span {
    margin-top: 10px;
    font-weight: 600;
    color: ${props => props.active ? '#007bff' : '#333'};
  }
`;

export const PaymentLogo = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
`;

export const SubscriptionInfo = styled.div`
  text-align: center;
  margin-bottom: 30px;

  h3 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1.8em;
  }

  p {
    color: #555;
    font-size: 1.1em;
    line-height: 1.6;
  }

  h4 {
   margin-top: 30px;
   margin-bottom: 15px;
   color: #333;
   font-size: 1.3em;
  }
`;
